import React from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../hooks/useLanguage";

const LunchMenu = () => {
  const { t, language } = useLanguage();

  return (
    <section className="py-16 bg-white dark:bg-gray-900">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <h2 className="text-4xl font-extrabold gradient-text">
            {language === "en" ? "Today's Lunch Menu" : "Päivän Lounasmenu"}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-primary to-secondary mx-auto my-6 rounded-full"></div>
          {/* <p className="text-lg text-gray-600 dark:text-gray-400">
            {language === "en"
              ? "Special lunch offerings available today"
              : "Tänään tarjolla olevat lounasannokset"}
          </p> */}
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="flex justify-center"
        >
          <img
             src="/assets/images/perjantaina.jpg" // Replace with the actual image path
            alt={language === "en" ? "Today's lunch menu" : "Päivän lounasmenu"}
            className="max-w-full rounded-lg shadow-xl hover:shadow-2xl transition-shadow duration-300"
          />
        </motion.div>

        <div className="text-center mt-8 text-sm text-gray-500 dark:text-gray-400">
          {language === "en"
            ? `Updated: ${new Date().toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric" })}`
            : `Päivitetty: ${new Date().toLocaleDateString("fi-FI", { weekday: "long", month: "long", day: "numeric" })}`}
        </div>
      </div>
    </section>
  );
};

export default LunchMenu;